import React, { Component } from 'react';
import YouTube from 'react-youtube';

class Video extends Component {
        
    youTubeGetID(url){
        url = url.split(/(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/)/);
        return undefined !== url[2] ? url[2].split(/[^0-9a-z_-]/i)[0] : url[0];
    }
    
    render() {
        return (
            <div className="nlf-viewer-block nlf-viewer-video">
                <YouTube videoId={this.youTubeGetID(this.props.data.url)} opts={ {width: '100%'} } />
            </div>
        )
    }
}

export default Video


// WEBPACK FOOTER //
// ./src/Video.js